import React from 'react';
import {
  FormattedMessage,
  defineMessages,
} from 'react-intl';
import environment from "lib/environment";
import { EmptyState, Link, Typography ,Button, AlertV2 } from '@getgo/chameleon-web-react-wrapper';
import { AdminStaticPictogram } from '@getgo/chameleon-pictograms/react';
import resolveRoute from 'lib/resolve-route';
import ClientSearchBarView from 'routes/clients/components/client-search-bar-view';
const apiReferenceUrl = environment.get().api_reference_url;
const learn_oauth = environment.get().learn_oauth;
import { Box } from '@mui/system';
import PropTypes from 'prop-types';

const t = defineMessages({
  'get.started.headline': {
    id: 'get.started.headline',
    defaultMessage: 'No OAuth clients yet',
    description: 'Headline for the get started screen',
  },
  'get.started.subtitle': {
    id: 'get.started.subtitle',
    defaultMessage: 'New OAuth clients will show up here.',
    description: 'Subtitle for the get started screen',
  },
  'get.started.api.documentation': {
    id: 'get.started.api.documentation',
    defaultMessage: 'Browse product APIs',
    description: 'Text and link to API documentation',
  },
  'get.started.oauth.clients': {
    id: 'get.started.oauth.clients',
    defaultMessage: 'Learn about OAuth clients',
    description: 'Text and link to understanding OAuth clients',
  },
  'get.started.create.client': {
    id: 'get.started.create.client',
    defaultMessage: 'Create a client',
    description: 'Button text for create client',
  },
  'client-info.search.not.found': {
    id: 'client-info.search.not.found',
    defaultMessage: 'No client found with the {searchValue}',
    description: 'Title for client search not found'
  },
});

const GetStartedView = ({
  onChange,
  searchValue,
  error,
  onSearch,
  ctaClicked,
  searchLoading,
  clientExist,
  showClientIdSearchInput
  }) => {
  return (
    <EmptyState
      icon={<AdminStaticPictogram />}
      title={
        <Typography variant="heading-small">
          <FormattedMessage {...t['get.started.headline']} />
        </Typography>
      }
      actions={
        <React.Fragment>
          <Link href={resolveRoute('clients.clientcreate')}>
            <Button>
              <FormattedMessage {...t['get.started.create.client']} />
            </Button>
          </Link>
          <Link href={apiReferenceUrl}>
            <Typography variant="body-small" color="#2C72DE">
              <FormattedMessage {...t['get.started.api.documentation']} />
            </Typography>
          </Link>
          <Link target="_blank" href={learn_oauth}>
            <Typography variant="body-small" color="#2C72DE">
              <FormattedMessage {...t['get.started.oauth.clients']} />
            </Typography>
          </Link>
          {showClientIdSearchInput &&
            <Box>
              <ClientSearchBarView
                onChange={onChange}
                searchValue={searchValue}
                error={error}
                onSearch={onSearch}
                fullWidth
              />
              {ctaClicked && !searchLoading && !clientExist &&
                <AlertV2 variant="danger">
                  <FormattedMessage
                    {...t['client-info.search.not.found']}
                    values={{
                    searchValue: searchValue,
                    }} />
                </AlertV2>}
            </Box>}

        </React.Fragment>
      }
    >
      <Typography color="#2A3238B2" variant="body-large">
        <FormattedMessage {...t['get.started.subtitle']} />
      </Typography>
    </EmptyState>
  );
};

GetStartedView.propTypes = {
  onChange: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  error: PropTypes.object.isRequired,
  onSearch: PropTypes.func.isRequired,
  ctaClicked: PropTypes.bool.isRequired,
  clientExist: PropTypes.bool.isRequired,
  searchLoading: PropTypes.bool.isRequired,
  showClientIdSearchInput: PropTypes.bool.isRequired,
};

export default GetStartedView;
